import { useParentAppLayout } from '@src/components/sco/AppLayout/AppLayoutContext'
import { ArticleLanding } from '@src/components/sco/Education/ArticleLanding'
import { ArticleSearch } from '@src/components/sco/Education/ArticleSearch'
import { useEducationContext } from '@src/components/sco/Education/EducationContext'
import { SEOMetadata } from '@src/components/sco/utilities/SEOMetadata'
import { useUniversalEffect } from '@src/hooks/useUniversalEffect'
import { EducationPage } from '@src/templates/EducationPage'

export { getServerSideProps } from '@src/lib/server-side-rendering'

export default EducationPage(function Page() {
  const layout = useParentAppLayout()
  const educationContext = useEducationContext()

  useUniversalEffect(() => {
    layout.updatePanel?.('edu-aside', { isPanelOpen: false })
    educationContext.setBreadcrumbs?.([{ title: 'Articles', href: '/articles' }])
    educationContext.setActiveSection?.('articles.landing')
  }, [])

  const showSearch = (educationContext.activeTerms?.length || 0) > 0 || !!educationContext.activeKeywords

  return (
    <>
      {showSearch ? (
        <ArticleSearch articleType={'ExpertAdvice'} typeTitle={'Articles'} />
      ) : (
        <ArticleLanding articleType={'ExpertAdvice'} />
      )}
      <SEOMetadata title={'Articles'} />
    </>
  )
})
